import api from '@/api/chat'
import { CHAT_SET_CONNECTION, CHAT_SET_ROOMS, CHAT_ADD_ROOM, CHAT_CLOSE_ROOM, CHAT_UPDATE_ROOM, CHAT_SET_ROOM_PARTICIPANTS, CHAT_ADD_PARTICIPANT, CHAT_SET_NOTIFICATIONS, CHAT_REMOVE_PARTICIPANT, CHAT_ADD_MESSAGE, CHAT_READ_MESSAGE, CHAT_ADD_HISTORY, CHAT_SET_USER_INFO } from './mutations'

import Chat from '@/utils/chat'

export default {
  connect: async ({ state, commit }) => {
    if (state.connection) {
      return
    }
    commit(CHAT_SET_CONNECTION, new Chat((e) => {
      const response = JSON.parse(e.data)
      switch (response.type) {
        case 'participants':
          commit(CHAT_SET_ROOM_PARTICIPANTS, response)
          break
        case 'history':
          commit(CHAT_ADD_HISTORY, response)
          break
        case 'notifications':
          commit(CHAT_SET_NOTIFICATIONS, response.notifications.chat)
          break
        case 'event':
          switch (response.event.type) {
            case 'message':
              commit(CHAT_ADD_MESSAGE, response.event)
              break
            case 'join':
              commit(CHAT_ADD_PARTICIPANT, response.event)
              break
            case 'disconnect':
              commit(CHAT_REMOVE_PARTICIPANT, response.event)
              break
          }
          break
        default:
          console.debug(response)
      }
    }))
  },
  notifications: ({ state, rootState }, parish) => {
    const action = 'notifications'
    parish = parish.id
    state.connection.send({
      action,
      parish,
      token: rootState.AuthModule.token
    })
  },
  read: ({ commit, state, rootState }, message) => {
    const action = 'read'
    state.connection.send({
      action,
      message: message.id,
      token: rootState.AuthModule.token
    })
  },
  join: ({ state, dispatch, rootState }, room) => {
    const action = 'join'
    room = room.id
    state.connection.send({
      action,
      room,
      token: rootState.AuthModule.token
    })
  },
  history: ({ state, dispatch, rootState }, { room, from, limit }) => {
    const action = 'history'
    room = room.id
    state.connection.send({
      action,
      room,
      from,
      limit,
      token: rootState.AuthModule.token
    })
  },
  send: ({ state, commit, rootState }, { room, message }) => {
    const action = 'message'
    room = room.id
    state.connection.send({
      action,
      room,
      message,
      token: rootState.AuthModule.token
    })
  },
  loadRoomsList: async ({ commit }, parish) => {
    let { rooms } = await api.loadRoomsList(parish)
    commit(CHAT_SET_ROOMS, rooms)
  },
  loadParticipantInfo: async ({ commit }, user) => {
    commit(CHAT_SET_USER_INFO, { user, info: { avatar: '', lastname: '', firstname: '' } })
    const { info } = await api.getUserInfo(user)
    commit(CHAT_SET_USER_INFO, { user, info })
  },
  openRoom: async ({ commit }, { parish, room }) => {
    const result = await api.openRoom(parish, room)
    commit(CHAT_ADD_ROOM, result.chat_room)
    return { message: result.message }
  },
  updateRoom: async ({ commit }, { room }) => {
    let result = await api.updateRoom(room)
    commit(CHAT_UPDATE_ROOM, result.chat_room)
    return { message: result.message }
  },
  closeRoom: async ({ commit }, { room }) => {
    const { message } = await api.closeRoom(room)
    commit(CHAT_CLOSE_ROOM, room)
    return { message }
  },
  readMessages: ({ state, commit }, room) => {
    if (!state.messages[room.id]) {
      return
    }
    state.messages[room.id].forEach(message => {
      commit(CHAT_READ_MESSAGE, message)
    })
  }
}
